<template>
  <Transition name="modal">
    <div v-if="showModalPwd" class="modal-mask">
      <div class="modal-container">
        <div class="modal-header">
          <div class="row w-100">
            <div class="d-flex justify-content-end pt-2">
              <button
                type="button"
                class="btn-close"
                @click="$emit('showModalForgotPassword', false)"
                aria-label="Close"
                style="right: -50px; font-size: 25px"
              ></button>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <form @submit.prevent="setEmail">
            <div class="container">
              <div class="row mt-2">
                <div class="col-lg-12">
                  {{ translate.msgSendMail }}
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mt-3">
                    <input
                      type="text"
                      class="form-control"
                      id="inputEmail"
                      aria-describedby="emailHelp"
                      :placeholder="translate.formResetEmail"
                      name="email"
                      v-model="email"
                    />
                  </div>
                  <div class="text-center mt-3" v-if="loading">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div class="col-4 d-w-btn" v-else>
                    <button>
                      {{ translate.btnSendMail }}
                      <i class="icon-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import api from "@/api";
import translaters from "@/tradutors/myaccount";

const props = defineProps(["showModalPwd", "emailUser"]);
const emits = defineEmits(["showModalMessages", "showModalForgotPassword"]);

const route = useRoute();
const translate = computed(() =>
  route.params.language === "pt-br" ? translaters.portugues : translaters.ingles
);

const email = ref("");
const loading = ref(false);

function setEmail() {
  loading.value = true;
  let requestOptions = {
    email: email.value,
    locale: route.params.language,
  };
  api.post("v1/password/email", requestOptions).then(({ data }) => {
    if (data["error"]) {
      emits("showModalMessages", {
        message: {
          show: true,
          title: "",
          textBoby: data["error"]["message"],
          textButton: translate.value.btnClose,
        },
      });
    } else {
      emits("showModalMessages", {
        message: {
          show: true,
          title: "",
          textBoby: data["success"]["message"],
          textButton: translate.value.btnClose,
        },
      });
      emits("showModalForgotPassword", false);
    }
    loading.value = false;
    email.value = "";
  });
}
onMounted(() => {
  email.value = props.emailUser;
});
watch(
  () => props.showModalPwd,
  (newVal) => {
    if (newVal) {
      email.value = props.emailUser;
    }
  },
  { immediate: true }
);
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9995;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 400px;
  margin: auto;
  padding: 20px 50px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.modal-body {
  margin: 20px 0;
}

.modal-footer {
  justify-content: center;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.form-group input {
  padding: 15px 20px;
  border-radius: 30px;
  margin-bottom: 15px;
  background-color: #f8f8f8;
  font-size: small;
}

input[type="text"]:focus {
  background-color: #f8f8f8;
}

.input-group-text {
  padding: 0;
  padding-left: 5px;
  font-size: 2rem;
  background-color: #f8f8f8;
  border: 1px solid #ced4da;
  border-radius: 30px;
  border-left-style: hidden;
  height: 51px;
}
.d-w-btn button {
  color: #fff;
  padding: 5px;
}

.d-w-btn {
  width: 130px;
  background: #000;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  color: #ffffff;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
}
/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .modal-container {
    width: 95%;
  }
}
</style>
